// extracted by mini-css-extract-plugin
export default {"legalCopy":"legalCopy_legalCopy__lWshC","legalCopy_sub_section":"legalCopy_legalCopy_sub_section__jWudr"};